import { AxiosRequestConfig } from "axios";
import apiClient from "./api.ts";

export const getAllFences = async (config: AxiosRequestConfig = {}) => {
    return apiClient.get(`/virtual-fences`, config);
};